/* 27 Oct 2026 - AUDIENCE LOG (owner approved): anonymous, banded events to the stylist's audience log, incl. people who never buy.
   Sends only: sid (random per browser session), ev, product handle, lang, size letter, 5 cm height band, 5 kg weight band, men/women.
   NEVER raw height/weight, names, emails, phones, free text. Silent when localStorage ascInternalOff === '1'. Never throws. */
(function () {
  if (window.__ascAudInit) return;
  window.__ascAudInit = 1;
  try {
    var d = document, w = window, URL_ = 'https://stylist.ascendiastore.com/api/audience-event';
    var EVS = { size_box_viewed: 1, size_box_used: 1, size_box_size_selected: 1, size_box_no_fit: 1, pdp_add_to_cart: 1, checkout_started: 1 };
    function off() { try { return w.localStorage.getItem('ascInternalOff') === '1'; } catch (e) { return false; } }
    function sid() {
      try {
        var s = w.sessionStorage.getItem('ascSid');
        if (s && /^[0-9a-f]{16}$/.test(s)) return s;
        var a = new Uint8Array(8); w.crypto.getRandomValues(a);
        s = Array.prototype.map.call(a, function (b) { return ('0' + b.toString(16)).slice(-2); }).join('');
        w.sessionStorage.setItem('ascSid', s);
        return s;
      } catch (e) { return ''; }
    }
    function band(v, step) { v = parseFloat(String(v).replace(',', '.')); if (!isFinite(v) || v <= 0) return ''; var lo = Math.floor(v / step) * step; return lo + '-' + (lo + step - 1); }
    function val(n) {
      var l = d.querySelectorAll('input[name="' + n + '"]');
      for (var i = 0; i < l.length; i++) if (l[i].offsetParent !== null && l[i].value.trim() !== '') return l[i].value;
      return '';
    }
    function gender() {
      try {
        var c = JSON.parse((d.querySelector('[data-asc-sg-config]') || {}).textContent || '{}');
        return c.g === 'w' ? 'women' : c.g === 'm' ? 'men' : '';
      } catch (e) { return ''; }
    }
    function aud(ev, size) {
      try {
        if (!EVS[ev] || off()) return;
        var s = sid(); if (!s) return;
        var h = parseFloat(val('h')), wt = parseFloat(val('w'));
        var p = { sid: s, src: 'sizebox', ev: ev,
          page: ((location.pathname.split('/products/')[1] || '').split(/[\/?#]/)[0] || '').slice(0, 80),
          lang: (d.documentElement.lang || 'en').slice(0, 2).toLowerCase(),
          size: /^(XXS|XS|S|M|L|XL|XXL|XXXL|[2-6]XL)$/.test(String(size || '').toUpperCase()) ? String(size).toUpperCase() : '',
          hband: h >= 100 && h <= 250 ? band(h, 5) : '', wband: wt >= 20 && wt <= 250 ? band(wt, 5) : '', gender: gender() };
        var body = JSON.stringify(p);
        setTimeout(function () {
          try {
            var ok = false;
            if (navigator.sendBeacon) ok = navigator.sendBeacon(URL_, new Blob([body], { type: 'text/plain' }));
            if (!ok && w.fetch) w.fetch(URL_, { method: 'POST', body: body, keepalive: true, mode: 'no-cors', headers: { 'Content-Type': 'text/plain' } }).catch(function () {});
          } catch (e) {}
        }, 0);
      } catch (e) {}
    }
    w.__ascAud = aud;
    function setCartSid() {
      try {
        if (off() || !w.fetch) return;
        var s = sid(); if (!s) return;
        var root = (w.Shopify && Shopify.routes && Shopify.routes.root) || '/';
        setTimeout(function () {
          w.fetch(root + 'cart/update.js', { method: 'POST', credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ attributes: { _asc_sid: s } }) }).catch(function () {});
        }, 1200);
      } catch (e) {}
    }
    d.addEventListener('click', function (e) {
      try {
        var t = e.target && e.target.closest ? e.target : null; if (!t || !e.isTrusted) return;
        if (t.closest('form[action*="/cart/add"] [name="add"], form[action*="/cart/add"] button[type="submit"]')) { aud('pdp_add_to_cart', ''); setCartSid(); }
        else if (t.closest('[name="checkout"], #checkout')) aud('checkout_started', '');
      } catch (er) {}
    }, true);
    var once = {}, wrap = d.querySelector('[data-asc-sg-quickwrap]') || d.querySelector('[data-asc-sg-under]');
    w.__ascAudOnce = function (ev, size) { if (once[ev + (size || '')]) return; once[ev + (size || '')] = 1; aud(ev, size); };
    if (wrap && 'IntersectionObserver' in w) {
      var io = new IntersectionObserver(function (es) {
        for (var i = 0; i < es.length; i++) if (es[i].isIntersecting && es[i].target.getClientRects().length) { io.disconnect(); w.__ascAudOnce('size_box_viewed', ''); return; }
      }, { threshold: 0.5 });
      io.observe(wrap);
    }
  } catch (e) {}
})();
/* Ascendia 8 Oct 2026 - size box tracking (tools/sizebox-tracking-9oct2026/REPORT.md).
   Three events, for judging the story ads: SizeBoxViewed (box on screen), SizeBoxUsed (she typed a height AND a weight and
   an answer appeared), SizeBoxSizeSelected (she tapped "Choose <size>").
   PRIVACY: never sends a number she typed. Only: event name, product handle, page language, and the size letter.
   Meta: the pixel lives in the Facebook & Instagram app's sandbox (no fbq on the page), so this sends the custom event
   to the same pixel with Meta's own image endpoint (no library, no PageView). If fbq ever appears on the page, it uses
   fbq('trackCustom') instead. Clarity: a tag + an event. Google: only if gtag/dataLayer is on the page (today it is not).
   Reads the box, never changes it. Any error is swallowed: the box must keep working. */
(function () {
  try {
    var PIXEL = '1056122657163873';
    var d = document, w = window;
    var wrap = d.querySelector('[data-asc-sg-quickwrap]') || d.querySelector('[data-asc-sg-under]');
    if (!wrap) return;
    var handle = ((location.pathname.split('/products/')[1] || '').split(/[\/?#]/)[0] || '').slice(0, 80);
    if (!handle) return;
    var lang = (d.documentElement.lang || 'en').slice(0, 2).toLowerCase();
    var sent = {};
    var SIZE = /^(XXS|XS|S|M|L|XL|XXL|XXXL|[2-6]XL)$/;
    function cleanSize(s) {
      s = String(s || '').replace(/\s+/g, '').toUpperCase();
      return SIZE.test(s) ? s : '';
    }
    function allowed(kind) {
      try {
        if (kind === 'marketing' && navigator.globalPrivacyControl === true) return false;
        var cp = w.Shopify && w.Shopify.customerPrivacy;
        if (cp) {
          if (kind === 'marketing' && typeof cp.marketingAllowed === 'function') return cp.marketingAllowed() !== false;
          if (kind === 'analytics' && typeof cp.analyticsProcessingAllowed === 'function') return cp.analyticsProcessingAllowed() !== false;
        }
      } catch (e) { /* no consent API: follow the store default, like the app pixel */ }
      return true;
    }
    function cookie(n) {
      var m = d.cookie.match(new RegExp('(?:^|; )' + n + '=([^;]*)'));
      return m ? decodeURIComponent(m[1]) : '';
    }
    function send(ev, size, once) {
      if (sent[once]) return;
      sent[once] = 1;
      try { var am = { SizeBoxUsed: 'size_box_used', SizeBoxSizeSelected: 'size_box_size_selected' }[ev]; if (am && w.__ascAudOnce) w.__ascAudOnce(am, size); } catch (e) {}
      var data = { product: handle, lang: lang };
      if (size) data.size = size;
      var eid = 'sb' + Date.now().toString(36) + Math.random().toString(36).slice(2, 8);
      if (allowed('marketing')) {
        try {
          if (typeof w.fbq === 'function') {
            w.fbq('trackSingleCustom', PIXEL, ev, data, { eventID: eid });
          } else {
            var q = 'id=' + PIXEL + '&ev=' + ev + '&eid=' + eid + '&dl=' + encodeURIComponent(location.href) +
              '&rl=' + encodeURIComponent(d.referrer || '') + '&if=false&ts=' + Date.now();
            for (var k in data) q += '&cd[' + k + ']=' + encodeURIComponent(data[k]);
            var fbp = cookie('_fbp'), fbc = cookie('_fbc');
            if (fbp) q += '&fbp=' + encodeURIComponent(fbp);
            if (fbc) q += '&fbc=' + encodeURIComponent(fbc);
            var img = new Image(1, 1);
            img.src = 'https://www.facebook.com/tr/?' + q;
          }
        } catch (e) {}
      }
      if (allowed('analytics')) {
        try {
          var gev = ev.replace(/([a-z])([A-Z])/g, '$1_$2').toLowerCase();
          if (typeof w.gtag === 'function') w.gtag('event', gev, { product: handle, size: size || undefined, language: lang });
          else if (w.dataLayer && typeof w.dataLayer.push === 'function') w.dataLayer.push({ event: gev, product: handle, size: size || undefined, language: lang });
        } catch (e) {}
        try {
          if (typeof w.clarity === 'function') {
            w.clarity('set', 'size_box', ev === 'SizeBoxViewed' ? 'viewed' : ev === 'SizeBoxUsed' ? 'used' : 'selected');
            w.clarity('event', ev);
          }
        } catch (e) {}
      }
    }
    /* 1. Viewed: half the box line on screen, once per page. */
    if ('IntersectionObserver' in w) {
      var io = new IntersectionObserver(function (es) {
        for (var i = 0; i < es.length; i++) {
          if (es[i].isIntersecting && es[i].target.getClientRects().length) { io.disconnect(); send('SizeBoxViewed', '', 'v'); return; }
        }
      }, { threshold: 0.5 });
      io.observe(wrap);
    }
    /* 2. Used: only after she typed (a remembered answer shown on load does not count). */
    var typed = false, timer = 0, timer2 = 0;
    function visibleVal(scope, names) {
      for (var i = 0; i < names.length; i++) {
        var l = scope.querySelectorAll('input[name="' + names[i] + '"]');
        for (var j = 0; j < l.length; j++) if (l[j].offsetParent !== null && l[j].value.trim() !== '') return true;
      }
      return false;
    }
    function hasField(scope, names) {
      for (var i = 0; i < names.length; i++) if (scope.querySelector('input[name="' + names[i] + '"]')) return true;
      return false;
    }
    function check(form, final) {
      if (!typed || sent.u) return;
      var H = ['h', 'h_ft'], W = ['w', 'w_lb', 'w_st'];
      if (!visibleVal(form, H)) return;
      if (hasField(form, W) && !visibleVal(form, W)) return;
      var res = form.querySelector('[data-asc-sg-result]');
      if (!res || res.hidden) return;
      var ans = res.querySelector('[data-asc-sg-answer]');
      if (!ans || !ans.textContent.trim()) return;
      var b = ans.querySelector('b');
      var size = cleanSize(b && b.textContent);
      /* a size letter = an answer; no letter (an honest "we do not cut this size") counts only once she stops typing */
      if (!size && !final) return;
      send('SizeBoxUsed', size, 'u');
      if (!size && final) { var bb = bandsOf(form); sendIssue('size_box_no_fit', { hband: bb.hband, wband: bb.wband }, 'nf'); try { if (w.__ascAudOnce) w.__ascAudOnce('size_box_no_fit', ''); } catch (e) {} }
    }
    d.addEventListener('input', function (e) {
      var t = e.target;
      if (!e.isTrusted || !t || !t.closest) return;
      var form = t.closest('[data-asc-sg-form]');
      if (!form) return;
      typed = true;
      clearTimeout(timer); clearTimeout(timer2);
      /* read the answer once she pauses (half-typed numbers are not an answer) */
      timer = setTimeout(function () { try { check(form, false); } catch (er) {} }, 900);
      timer2 = setTimeout(function () { try { check(form, true); } catch (er) {} }, 2500);
    }, true);
    /* 26 Oct 2026 - SIZE ISSUES (measure only, nothing visible changes). Why: strangers' deep visits go to the size step and some hit a size we
       do not make or a sold-out size, then leave. Three events, Clarity + PostHog (if present) only, no Meta, no new request:
         size_unavailable_selected  a sold-out size/colour was picked (the sold-out panel appeared)
         size_out_of_range_message  "XL+" chip tapped, or the box answered "may be too small / biggest size"
         size_box_no_fit            the box finished with no size letter (we do not cut this size)
       PRIVACY: bands only (10 cm / 10 kg), never the numbers typed. Respects ?internal=1 (localStorage ascInternalOff) and the Shopify
       analytics consent. */
    var issueSent = {};
    function internalOff() { try { return w.localStorage && w.localStorage.getItem('ascInternalOff') === '1'; } catch (e) { return false; } }
    function band(v, step) { v = parseFloat(String(v).replace(',', '.')); if (!isFinite(v) || v <= 0) return ''; var lo = Math.floor(v / step) * step; return lo + '-' + (lo + step - 1); }
    function bandsOf(form) {
      var out = { hband: '', wband: '' };
      try {
        var hi = form && form.querySelector('input[name="h"]'), hf = form && form.querySelector('input[name="h_ft"]');
        var wi = form && form.querySelector('input[name="w"]'), wl = form && form.querySelector('input[name="w_lb"]');
        if (hi && hi.value && parseFloat(hi.value) >= 100) out.hband = band(hi.value, 10) + 'cm'; else if (hf && hf.value) out.hband = 'ft';
        if (wi && wi.value && parseFloat(wi.value) >= 20) out.wband = band(wi.value, 10) + 'kg'; else if (wl && wl.value) out.wband = 'lb';
      } catch (e) {}
      return out;
    }
    function refParam() { try { return (new URLSearchParams(location.search).get('ref') || '').slice(0, 40); } catch (e) { return ''; } }
    function pickedOptions() {
      var size = '', colour = '';
      try {
        var ins = d.querySelectorAll('.product__info-container variant-radios input:checked, .product__info-container variant-selects select');
        for (var i = 0; i < ins.length; i++) {
          var v = ins[i].tagName === 'SELECT' ? (ins[i].options[ins[i].selectedIndex] || {}).value : ins[i].value;
          v = String(v || '').trim(); if (!v) continue;
          if (cleanSize(v)) { if (!size) size = cleanSize(v); } else if (!colour) colour = v.slice(0, 40);
        }
      } catch (e) {}
      return { size: size, colour: colour };
    }
    function sendIssue(ev, extra, once) {
      if (once && issueSent[once]) return;
      if (once) issueSent[once] = 1;
      if (internalOff() || !allowed('analytics')) return;
      var props = { product: handle, lang: lang, ref: refParam() };
      for (var k in (extra || {})) if (extra[k]) props[k] = extra[k];
      try { if (w.posthog && typeof w.posthog.capture === 'function') w.posthog.capture(ev, props); } catch (e) {}
      try { if (typeof w.clarity === 'function') { w.clarity('set', 'size_issue', 'yes'); w.clarity('event', ev); } } catch (e) {}
    }
    /* (a) a sold-out size or colour picked: the sold-out panel (.asc-so) shows after the variant change */
    d.addEventListener('change', function (e) {
      var t = e.target;
      if (!e.isTrusted || !t || !t.closest || !t.closest('.product__info-container variant-radios, .product__info-container variant-selects')) return;
      setTimeout(function () {
        try {
          var panel = d.querySelector('.asc-so:not([hidden])');
          if (!panel || !d.body.classList.contains('asc-so-on')) return;
          var o = pickedOptions();
          sendIssue('size_unavailable_selected', { size: o.size, colour: o.colour }, 'ua' + o.size + '|' + o.colour);
        } catch (er) {}
      }, 600);
    }, true);
    /* (b1) the "XL+" chip (round 5): we make this style up to L */
    d.addEventListener('click', function (e) {
      var c = e.target && e.target.closest && e.target.closest('.asc-r5-upchip, [data-r5-up]');
      if (!c || !e.isTrusted) return;
      var mm = String(c.textContent || '').match(/[A-Za-z0-9]+/), sz = cleanSize(mm ? mm[0] : '');
      sendIssue('size_out_of_range_message', { size: sz ? sz + '+' : '', source: 'chip' }, 'oc');
    }, true);
    /* (b2) the box answered "may be too small" (result gets .is-tight), (c) no size letter at all */
    try {
      var resEl = d.querySelector('[data-asc-sg-quickwrap] [data-asc-sg-result], [data-asc-sg-under] [data-asc-sg-result]');
      if (resEl && 'MutationObserver' in w) {
        new MutationObserver(function () {
          try {
            if (!typed || resEl.hidden || !resEl.classList.contains('is-tight')) return;
            var f = resEl.closest('[data-asc-sg-form]') || d.querySelector('[data-asc-sg-form]');
            var b = bandsOf(f);
            sendIssue('size_out_of_range_message', { source: 'box_tight', hband: b.hband, wband: b.wband }, 'ot');
          } catch (er) {}
        }).observe(resEl, { attributes: true, attributeFilter: ['class', 'hidden'] });
      }
    } catch (e) {}
    /* 3. Size selected: the "Choose <size>" button. Capture phase, before the box's own handler. */
    d.addEventListener('click', function (e) {
      var t = e.target && e.target.closest && e.target.closest('[data-asc-sg-choose]');
      if (!t) return;
      var s = cleanSize(t.getAttribute('data-size'));
      send('SizeBoxSizeSelected', s, 's' + s);
    }, true);
  } catch (e) { /* tracking must never break the page */ }
})();
